import React from 'react';

export const Close2Icon = (props: any) => {
  return (
    <svg
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M30.5742 28.4934L2.85583 0.77507L0.0274351 3.60347L27.7458 31.3218L30.5742 28.4934Z" />
      <path d="M30.6 3.40006L2.8 31.2001L0 28.4001L27.7 0.500061L30.6 3.40006Z" />
    </svg>
  );
};
